import React from 'react';
import PropTypes from 'prop-types';
import { Col, SplitButton, Dropdown, DropdownButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { find, isEmpty, map } from 'lodash';

const ColSplitButton = ({
  xs,
  sm,
  md,
  lg,
  xl,
  variant,
  size,
  disabled,
  alignRight,
  icon,
  spin,
  spanLabel,
  dropdownItems,
  dropdownSubItems,
  onSelect,
  downloadVideo
}) => {
  const handleSelectMenu = (item, format) => {
    if (item === 'Annotations') onSelect(format);
    else downloadVideo(item, format);
  };
  return (
    <Col
      as={SplitButton}
      xs={xs}
      sm={find([sm, xs], colSize => colSize > 0)}
      md={find([md, sm, xs], colSize => colSize > 0)}
      lg={find([lg, md, sm, xs], colSize => colSize > 0)}
      xl={find([xl, lg, md, sm, xs], colSize => colSize > 0)}
      variant={variant}
      className="border m-0 p-0 btn"
      size={size}
      disabled={disabled}
      alignRight={alignRight}
      title={
        <div className="d-flex d-flex-row align-items-center justify-content-center">
          {!isEmpty(icon) && <FontAwesomeIcon icon={icon} size="lg" spin={spin} />}
          <span className="pl-1 flex-grow-1">{spanLabel}</span>
        </div>
      }
    >
      {map(dropdownItems, item => (
        <DropdownButton variant="light" title={item} key={item}>
          {map(dropdownSubItems, format => (
            <Dropdown.Item
              key={format}
              eventKey={format}
              onSelect={() => handleSelectMenu(item, format)}
            >
              {format}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      ))}
    </Col>
  );
};

ColSplitButton.defaultProps = {
  xs: 12,
  sm: 0,
  md: 0,
  lg: 0,
  xl: 0,
  variant: 'primary',
  size: '',
  disabled: false,
  alignRight: false,
  icon: '',
  spin: false,
  dropdownSubItems: [],
  downloadVideo: () => {}
};

ColSplitButton.propTypes = {
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  alignRight: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  spin: PropTypes.bool,
  spanLabel: PropTypes.string.isRequired,
  dropdownItems: PropTypes.array.isRequired,
  dropdownSubItems: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  downloadVideo: PropTypes.func
};

export default ColSplitButton;
